
import { createAsyncThunk } from "@reduxjs/toolkit";
import { iStateMessage } from "@/customTypes/GenericReduxTypes";
import { iGenericResponse } from "@/customTypes/CommonServiceTypes";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { customerService } from "@/services/api/cresivoxServer";
import { REDUCER_NAME } from './Types';

const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const getResellerList = createAsyncThunk<
  iGenericResponse<any | null> | null,
  { search?: string; page?: number; limit?: number } | void,
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("resellerList"),
  // @ts-expect-error
  async (arg, { rejectWithValue }) => {
    try {
      const search = arg && typeof arg === 'object' ? arg.search : undefined;
      const page = arg && typeof arg === 'object' ? arg.page : undefined;
      const limit = arg && typeof arg === 'object' ? arg.limit : undefined;

      const response = search 
        ? await customerService.searchResellers(search, page, limit)
        : await customerService.getAllReseller(page, limit);
      
      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              // Sorting by created_at descending
              const sortedData = [...data.data].sort((a, b) => {
                return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
              });

              return {
                data: {
                  httpStatusCode,
                  data: sortedData,  // Sorted data
                  message,
                }
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);
